export const companyQueryKeys = {
    all: ['company'] as const,
    available: () => [...companyQueryKeys.all, 'available'] as const,
    setActive: () => [...companyQueryKeys.all, 'set-active'] as const,
};
